/**
 * utils/noBrowserAutocomplete.js
 * Turns off the BROWSER's own "things you typed here before" dropdown on every text field in
 * the app (Chalton's request, 2026-10-11). That list (e.g. old names under the Pembeli field) is
 * Chrome's, not ours — it covered the app's own suggestion lists (contacts, sales, items) and
 * piled up with every test entry typed. The app's own pickers are unaffected.
 *
 * One place, not an attribute on each of the ~120 inputs: a MutationObserver stamps
 * `autocomplete="off"` onto every <input>/<textarea> as it appears, so a field added later can't
 * forget it. A field that already sets its own `autocomplete` is left alone. Called once from
 * index.js. Returns a function that stops observing (used by tests).
 */
const FIELD_SELECTOR = "input, textarea";

function stamp(el) {
  if (el.matches && el.matches(FIELD_SELECTOR) && !el.hasAttribute("autocomplete")) {
    el.setAttribute("autocomplete", "off");
  }
}

function stampTree(node) {
  if (node.nodeType !== 1) return;
  stamp(node);
  node.querySelectorAll(FIELD_SELECTOR).forEach(stamp);
}

export function disableBrowserAutocomplete(root = document.body) {
  stampTree(root);
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) m.addedNodes.forEach(stampTree);
  });
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
}
